import { Snapshot } from '@ember-data/store';
import type { Promise as RsvpPromise } from 'rsvp';
import type ModelRegistry from 'ember-data/types/registries/model';
import ApplicationAdapter from 'uplisting-frontend/adapters/application';

type ActionKey = 'update_plan' | 'switch_template';

const ACTION_ATTR_MAP: Record<ActionKey, string> = {
  update_plan: 'dbePlan',
  switch_template: 'templateAlias',
};

interface ActionAdapterOptions {
  action?: ActionKey;
}

export default class DudaConfigurationAdapter extends ApplicationAdapter {
  buildURL<K extends keyof ModelRegistry>(
    modelName?: K,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    id?: string | any[] | object | null,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    snapshot?: Snapshot<K> | any[] | null,
    requestType?: string,
    query?: object,
  ): string {
    const url = super.buildURL(modelName, id, snapshot, requestType, query);
    const action = this.actionFor(snapshot);

    return action ? `${url}/${action}` : url;
  }

  updateRecord(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    store: any,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    type: any,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    snapshot: any,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ): RsvpPromise<any> {
    const action = this.actionFor(snapshot);

    if (!action) {
      return super.updateRecord(store, type, snapshot);
    }

    const snapshotAttr = ACTION_ATTR_MAP[action];
    const payloadKey = store
      .serializerFor(type.modelName)
      .keyForAttribute(snapshotAttr);
    const data = {
      data: { attributes: { [payloadKey]: snapshot.attr(snapshotAttr) } },
    };

    const url = this.buildURL(
      type.modelName,
      snapshot.id,
      snapshot,
      'updateRecord',
    );

    return this.ajax(url, 'POST', { data });
  }

  private actionFor(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    snapshot?: Snapshot | any[] | null,
  ): ActionKey | undefined {
    if (!snapshot || Array.isArray(snapshot)) {
      return undefined;
    }

    return (snapshot.adapterOptions as ActionAdapterOptions | undefined)
      ?.action;
  }
}

declare module 'ember-data/types/registries/adapter' {
  interface AdapterRegistry {
    'duda-configuration': DudaConfigurationAdapter;
  }
}
